export default __webpack_public_path__ + "static/media/who.0894bc34.gif";